//Librairies
import React,{useRef,useEffect} from 'react';
import ScrollIntoView from 'react-scroll-into-view'
import styled from "styled-components";
import { gsap } from "gsap";


//Icons
import {AiOutlineHome} from 'react-icons/ai';
import {MdWorkOutline} from 'react-icons/md';
import {TiContacts} from 'react-icons/ti';
import {MdPersonOutline} from 'react-icons/md';

const NavMenu = ({timeline}) => {

    const elementUl = useRef();
    const socialDom = gsap.utils.selector(elementUl);

    useEffect(() => {
        timeline.from((".menu"),{
            y:100,
            duration:.8
        })
    },[])


    return (
        <Nav>
            <ul ref={elementUl} className="menu">
                <ScrollIntoView selector="#accueil">
                    <li><AiOutlineHome  className="social"/></li>
                </ScrollIntoView>
                <ScrollIntoView selector="#about">
                    <li><MdPersonOutline className="social"/></li>
                </ScrollIntoView>
                <ScrollIntoView selector="#projets">
                    <li><MdWorkOutline className="social"/></li>
                </ScrollIntoView>
                <ScrollIntoView selector="#contact" >
                    <li><TiContacts className="social"/></li>
                </ScrollIntoView>
            </ul>
        </Nav>
    );
};

const Nav = styled.nav`
  position: fixed;
  transform: rotate(90deg) translateY(135px);
  bottom: 50%;
  z-index: 999;
  overflow: hidden;
  .social{
      font-size: 30px;
    }

  ul {
    display: flex;
    background: rgba(208, 208, 208, 0.18);
    justify-content: space-evenly;
    align-items: center;
    list-style: none;
    padding: 15px;
    border-radius: 4rem;
    min-width: 400px;
    backdrop-filter: blur(10px);
  }

  ul li {
    z-index: 2;
    transform: rotate(270deg);
  }

  ul li:hover {
    background: rgba(189, 189, 189, 0.46);
    border-radius: 30px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    transform: rotate(180deg);
    bottom: 2%;
    width: 100%;
    display: grid;
    place-items: center;
    
    // icons 
    .social{
      font-size: 24px;
    }

    ul {
      min-width: 80%;
    }
    ul li {
      z-index: 2;
      transform: rotate(180deg);
      width: 100%;
    }
  }
`

export default NavMenu;